<template>
  <div
    v-cloak
    v-loading.fullscreen.lock="dataLoading"
    element-loading-text="Loading, please wait..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-dialog
      title="Activate Banner"
      :visible.sync="confirmToActivateDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="tiny"
    >
      <div class="dialog">Confirm to activate banner?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleActivate">OK</el-button>
        <el-button @click="confirmToActivateDialogVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
    <!-- validation process 的弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="validationDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="700px"
      size="tiny"
    >
      <div class="dialog">{{validationDialogContent}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleValidation" :loading="submitEditLoading">确认</el-button>
        <el-button @click="validationDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Modify Detail"
      :visible.sync="confirmToEditBannerDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="920px"
      size="tiny"
    >
      <b>Before</b>
      <banner-modify :data="[selectRow]"></banner-modify>

      <b>After</b>
      <banner-modify :data="[editBannerBean]"></banner-modify>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="modifyBanner" :loading="submitEditLoading">Submit</el-button>
        <el-button size="small" @click="confirmToEditBannerDialogVisible = false" class="ml30">Cancel</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Inactivate Banner"
      :visible.sync="confirmToInactivateDialogVisible"
      @close="clearBannerKeys"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="tiny"
    >
      <div class="dialog">Confirm to inactivate banner?</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handleInactivate" style="width: 70px">OK</el-button>
        <el-button size="small" @click="confirmToInactivateDialogVisible = false" class="ml30">Cancel</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="bannerDiaTitle"
      :visible.sync="addBannerGroupDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="small"
    >
      <div class="add-banner-group">
        <el-form label-position="left" label-width="120px">
          <el-form-item label="Banner Group CN: " required>
            <el-input v-model="bannerGroup.banner_group_name_cn" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Banner Group EN: " required>
            <el-input v-model="bannerGroup.banner_group_name_en" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" size="small" @click="saveBannerGroup" :loading="CreateBannerGroupLoading">Submit</el-button>
        <el-button size="small" class="ml30" @click="addBannerGroupDialogVisible = false,CreateBannerGroupLoading=false">Cancel</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Create Banner"
      :visible.sync="addBannerDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="550px"
      size="small"
    >
      <el-form label-position="left" label-width="190px">
        <el-form-item label="Banner CN: " required>
          <el-input
            v-model="addBannerBean.banner_name_cn"
            size="small"
            title="Please input banner name"
          ></el-input>
        </el-form-item>
        <el-form-item label="Banner EN: " required>
          <el-input
            v-model="addBannerBean.banner_name_en"
            size="small"
            title="Please input banner name"
          ></el-input>
        </el-form-item>

        <el-form-item label="Banner Group: " required>
          <div class="banner-group-select-group">
            <el-select
              :popper-append-to-body="false"
              v-model="addBannerBean.banner_group_id"
              size="small"
              filterable
            >
              <template v-for="(option, optIdx) in bannerGroupOptional">
                <el-option
                  :key="optIdx"
                  :label="option.banner_group_name_cn+ ' ' + option.banner_group_name_en"
                  :value="option.banner_group_id"
                >
                  <span style="float: left">{{ option.banner_group_name_cn + ' ' + option.banner_group_name_en }}</span>
                  <span class="banner-group-edit" style="" @click.stop="editBannerGroup(option,'create')">Edit</span>
                </el-option>
              </template>
            </el-select>
            <el-button
              size="mini"
              type="success"
              @click="createBanner('Create')"
            >
              Create
            </el-button>
          </div>
        </el-form-item>

        <el-form-item label="Dominant Channel Type: " required>
          <el-select
            v-model="addBannerBean.banner_channel"
            size="small"
            style="width: 100%"
            :disabled="role === 'EM'"
            @change="changeBannerChannel(addBannerBean)"
          >
            <template v-for="(option, optIdx) in bannerChannelOptionalForUser">
              <el-option :label="option" :key="optIdx" :value="option"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item label="Banner Type: " required>
          <el-select v-model="addBannerBean.banner_type_id" size="small" style="width: 100%">
            <template v-for="(option, optIdx) in addBannerTypeList">
              <el-option :label="option.banner_type_code" :key="optIdx" :value="option.id"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <!--create 的date-picker  添加effective date选择，只能选大于当前的时间  yyyy-mm -->
        <el-form-item label="Effective Date: " required>
          <el-date-picker
            v-model="addBannerBean.effective_from"
            align="right"
            type="date"
            size="small"
            style="width: 100%"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            format="yyyy-MM"
            value-format="yyyy-MM"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="saveBanner" :loading="submitSaveCreatLoading" size="small">Submit</el-button>
        <el-button @click="addBannerDialogVisible = false" class="ml30" size="small">Cancel</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Modify Banner"
      :visible.sync="editBannerDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="550px"
      size="small"
    >
      <el-form label-position="left" label-width="190px">
        <el-form-item label="Banner CN: " required>
          <el-input
            v-model="editBannerBean.banner_name_cn"
            size="small"
            title="Please input banner name"
          ></el-input>
        </el-form-item>
        <el-form-item label="Banner EN: " required>
          <el-input
            v-model="editBannerBean.banner_name_en"
            size="small"
            title="Please input banner name"
          ></el-input>
        </el-form-item>

        <el-form-item label="Banner Group: " required>
          <div class="banner-group-select-group">
            <el-select
              :popper-append-to-body="false"
              v-model="editBannerBean.banner_group_id"
              size="small"
              @change="changeBannerGroup(editBannerBean)"
              filterable
            >
              <template v-for="(option, optIdx) in bannerGroupOptional">
                <el-option
                  :key="optIdx"
                  :label="option.banner_group_name_cn + ' ' + option.banner_group_name_en"
                  :value="option.banner_group_id"
                >
                  <span style="float: left">{{ option.banner_group_name_cn + ' ' + option.banner_group_name_en }}</span>
                  <span class="banner-group-edit" style="" @click.stop="editBannerGroup(option, 'modify')">Edit</span>
                </el-option>
              </template>
            </el-select>
            <el-button
              size="mini"
              type="success"
              @click="createBanner('Modify')"
            >
              Create
            </el-button>
          </div>
        </el-form-item>

        <el-form-item label="Dominant Channel Type: " required>
          <el-select
            v-model="editBannerBean.banner_channel"
            size="small"
            style="width: 100%"
            @change="changeBannerChannel(editBannerBean, true)"
          >
            <template v-for="(option, optIdx) in Object.keys(bannerChannelOptional)">
              <el-option :label="option" :key="optIdx" :value="option"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item label="Banner Type: " required>
          <el-select
            v-model="editBannerBean.banner_type_id"
            size="small"
            style="width: 100%"
            @change="changeBannerType(editBannerBean)"
          >
            <template v-for="(option, optIdx) in editBannerTypeList">
              <el-option :label="option.banner_type_code" :key="optIdx" :value="option.id"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <!-- edit的date-picker -->
        <el-form-item label="Effective Date: " required>
          <el-date-picker
            v-model="editBannerBean.effective_from"
            align="right"
            type="date"
            size="small"
            style="width: 100%"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            format="yyyy-MM"
            value-format="yyyy-MM"
          ></el-date-picker>
        </el-form-item>

        <!--<el-form-item label="Is Top Banner: "  required>-->

        <!--<el-select v-model="editBannerBean.top_banner" size="small">-->
        <!--<el-option label="Y" value="true"></el-option>-->
        <!--<el-option label="N" value="false"></el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="confirmEditBanner" size="small">Confirm</el-button>
        <el-button @click="editBannerDialogVisible = false" size="small" class="ml30">Cancel</el-button>
      </span>
    </el-dialog>
    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li class="active">
          <small>Store</small>
        </li>
        <li class="active">
          <small>Distributor Store</small>
        </li>
        <li class="active">
          <small>Banner Management</small>
        </li>
      </ol>
    </div>
    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Detail">
          <d1-vue-component
            ref="basicComponent"
            :options="generateOption"
            data-facet-key="ALL_BANNER_LATEST"
            :whetherNeedPropPageTableType="true"
            :d1CoreBaseUrl="baseD1Url"
            :ControlMoreSeachType="true"
            :selectControlView="false"
            :MoreAndSearchClickView="false"
            :CategorySelectionControlMyDefault="CategorySelectionControlMyDefault"
            @handleTableValueClick="handleTableValueClick"
            @handleTableDataFormatter="handleTableDataFormatter"
            @onTableOperationButtonClick="handleTableButtonClick"
            v-on:listenCategorySelectionControlMyDefault="listenCategorySelectionControlMyDefaultParent"
            @onToolbarButtonClick="handleToolbarButtonClick"
          ></d1-vue-component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import d1VueComponent from "@/components/d1/d1-vue-component";
import bannerModify from "@/view/store/banner_master/banner_modify.vue";
import store from "@/store";
import util from "@/util/util";
export default {
  components: {
    d1VueComponent,
    bannerModify
  },
  data() {
    return {
      submitSaveCreatLoading:false,
      submitEditLoading:false,
      thebannertypefirstpageDataJudge: true, //对比前后两次的选择结果，进行记录。可以判断bannertype是否改变
      thebannertypesecendpage: "",
      thebannertypefirstpage: "",
      bannerTypeHasChanged: false,
      whetherNeedValidation: true,
      needValidationJudge: true,
      validationDialogContent: "",
      validationDialogVisible: false,
      CategorySelectionControlMyDefault: false,
      addBannerDialogVisible: false,
      editBannerDialogVisible: false,
      confirmToActivateDialogVisible: false,
      confirmToInactivateDialogVisible: false,
      addBannerGroupDialogVisible: false,
      confirmToEditBannerDialogVisible: false,
      editBannerBean: {
        banner_type_id: "",
        banner_name_cn: "",
        banner_name_en: "",
        banner_group_id: "",
        banner_channel: "",
        top_banner: "",
        effective_from:''
      },
      bannerGroup: {
        banner_group_name_cn: "",
        banner_group_name_en: ""
      },
      addBannerBean: {
        banner_type_id: "",
        banner_name_cn: "",
        banner_name_en: "",
        banner_group_id: "",
        banner_channel: "",
        effective_from: ''
      },
      generateOption: {
        queryUrl: "/dms/banner/list?sort=gmt_modified,DESC",
        importUrl: "",
        exportUrl: "/dms/banner/list/export?sort=gmt_modified,DESC",
        deleteUrl: "",
        modifyUrl: "",
        pageSize: 10,
        tableData: [{}],
        pageSettingData: {
          form: [{}],
          table: [{}]
        },
        showToolbarButtonList: false,
        asyncExport: true,
        showExportButton: true,
        showTableSelection: true,
        showTableOperationButton: false,
        tableDataFormatter: true,
        openform: true,
        tableCellDataLink: [
          {
            db_field_name: "approve_email", //需要增加a标签的字段名
            field_label: [""], //a标签显示的限制值
            dialogDisplaysValueFromFields: "", // 对话框的说明来源于字段
            needCustomProcess: true, //如果设置为ture
            name: ""
          },
          {
            db_field_name: "banner_id", //需要增加a标签的字段名
            field_label: [""], //a标签显示的限制值
            dialogDisplaysValueFromFields: "", // 对话框的说明来源于字段
            needCustomProcess: true, //如果设置为ture
            name: ""
          },
          {
            db_field_name: "pi_status", //需要增加a标签的字段名
            field_label: [""], //a标签显示的限制值
            dialogDisplaysValueFromFields: "", // 对话框的说明来源于字段
            needCustomProcess: true, //如果设置为ture
            name: ""
          }
        ],
        showSelectColumn: true,
        pageTableType: "banner_all",
        ExchangeToolbarButtonPosition: true
      },
      bannerChannelOptional: {},
      createBannerChannelOptional: {},
      bannerChannelOptionalForUser: [],
      bannerGroupOptional: [],
      bannerTypeTop: {},
      dataLoading: false,
      bannerKeyIds: [],
      selectRow: {},
      // 区分group的是什么类型
      operationGroupType: {
        create: "create",
        modify: "modify"
      },
      // 根据这个条件去gei相应model赋值
      openGroupType: "",
      ExchangeToolbarButtonPosition: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      CreateBannerGroupLoading:false,
      bannerDiaTitle: "Create Banner Group",
    };
  },
  watch: {},
  computed: {
    addBannerTypeList() {
      let bannerTypeList = this.addBannerBean.banner_channel
        ? this.createBannerChannelOptional[this.addBannerBean.banner_channel]
        : "";
      // if (bannerTypeList) {
      //   if (this.role === "AE") {
      //     return bannerTypeList.filter(bannerType => {
      //       return bannerType.is_top_banner;
      //     });
      //   } else if (this.role === "KAM" || this.role === "UM") {
      //     return bannerTypeList.filter(bannerType => {
      //       return !bannerType.is_top_banner;
      //     });
      //   }
      //    //超级管理员不做筛选
      //   if(this.isSuper){
      //     return bannerTypeList
      //   }
      // }
      return bannerTypeList;
    },
    editBannerTypeList() {
      return this.editBannerBean.banner_channel
        ? this.bannerChannelOptional[this.editBannerBean.banner_channel]
        : "";
    },
    role() {
      return this.$store.getters.getRole;
    },
    isSuper(){
      // console.log(this.$store)
      if(this.$store.getters.getSuperRoles.includes(this.$store.getters.getRole)){
        return true
      }else {
        return false
      }
    }
  },
  created() {
    this.handleAccessControl();
    this.getBannerChannel();
    this.getCreateBannerChannel();
    this.getBannerGroup();
  },
  mounted() {},
  methods: {
    listenCategorySelectionControlMyDefaultParent(data) {
      this.CategorySelectionControlMyDefault = !this
        .CategorySelectionControlMyDefault;
      //console.log(data)
      //console.log(this.CategorySelectionControlMyDefault)
    },
    getBannerGroup(controlLoadingFlag) {
      let url = this.baseStoreUrl + "/dms/banner-group/list";
      this.http
        .get(url)
        .then(resp => {
          let data = resp.data;
          if (data) {
            this.bannerGroupOptional = data;

            if (controlLoadingFlag) {
              this.CreateBannerGroupLoading = false
              this.dataLoading = false;
            }
          }
        })
        .catch(error => {
          console.info(error);
        });
    },
    // bannerChannelOptionalFoCreate() {
      // if (this.role === "AE") {
      //   let channelList = Object.keys(this.bannerChannelOptional);
      //   return channelList.filter(channel => {
      //     return this.bannerChannelOptional[channel].filter(bannerType => {
      //       return bannerType.is_top_banner;
      //     }).length;
      //   });
      // } else if (this.role === "KAM" || this.role === "UM") {
      //   let channelList = Object.keys(this.bannerChannelOptional);
      //   return channelList.filter(channel => {
      //     return this.bannerChannelOptional[channel].filter(bannerType => {
      //       return !bannerType.is_top_banner;
      //     }).length;
      //   });
      // } else {
      //   return Object.keys(this.bannerChannelOptional);
      // }
      // if(this.isSuper){
      //   //超级管理员的modify  Channel Type  不需要筛选
      //   return Object.keys(this.bannerChannelOptional);
      // }
      // return Object.keys(this.bannerChannelOptional);
    // },
    getBannerChannel() {
      let url = this.baseStoreUrl + "/dms/banner/banner-type-list";
      this.http
        .get(url)
        .then(resp => {
          let data = resp.data;
          if (data) {
            for (let i = 0; i < data.length; i++) {
              if (this.bannerChannelOptional[data[i].channel_type_code]) {
                this.bannerChannelOptional[data[i].channel_type_code].push(data[i]);
              } else {
                let bannerTypeList = [];
                bannerTypeList.push(data[i]);
                this.bannerChannelOptional[data[i].channel_type_code] = bannerTypeList;
              }
              this.bannerTypeTop[data[i].id] = data[i].is_top_banner;
            }
            // this.bannerChannelOptionalForUser = this.bannerChannelOptionalFoCreate();
          }
        })
        .catch(error => {
          console.info(error);
        });
    },
    // 获取 创建 Banner时的 Dominant Channel Type 列表
    getCreateBannerChannel() {
      let url = this.baseStoreUrl + "/dms/banner/bannerTypeListForCreate";
      this.http
        .get(url)
        .then(resp => {
          let data = resp.data;
          if (data) {
            for (let i = 0; i < data.length; i++) {
              if (this.createBannerChannelOptional[data[i].channel_type_code]) {
                this.createBannerChannelOptional[data[i].channel_type_code].push(data[i]);
              } else {
                let bannerTypeList = [];
                bannerTypeList.push(data[i]);
                this.createBannerChannelOptional[data[i].channel_type_code] = bannerTypeList;
              }
              // this.bannerTypeTop[data[i].id] = data[i].is_top_banner;
            }
            this.bannerChannelOptionalForUser = Object.keys(this.createBannerChannelOptional);
          }
        })
        .catch(error => {
          console.info(error);
        });
    },
    handleAccessControl() {
      //权限控制
      let role = this.$store.getters.getRole;
      if (["Category Sales Executive", "AE", "KAM", "UM", "PM"].includes(role)) {
        this.generateOption.showToolbarButtonList = true;
        this.generateOption.showTableOperationButton = true;
        this.generateOption.tableOperationButtonList = [
          {
            label: "Modify", //按钮显示的名称
            type: "", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "modify", // 按钮点击时间触发的函数名称
            width: 100
          }
        ];
        this.generateOption.toolbarButtonList = [
          {
            label: "Create ", //按钮显示的名称
            type: "success", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "create", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          }
        ];
      } else if (["Store System Admin", "Master Data Admin"].includes(role)) {
        this.generateOption.showToolbarButtonList = true;
        this.generateOption.showTableOperationButton = true;
        this.generateOption.toolbarButtonList = [];
        this.generateOption.tableOperationButtonList = [
          {
            label: "Modify", //按钮显示的名称
            type: "", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "modify", // 按钮点击时间触发的函数名称
            width: 100
          }
        ];
        this.generateOption.toolbarButtonList = [
          {
            label: "Create ", //按钮显示的名称
            type: "success", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "create", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          },
          {
            label: "Activate ", //按钮显示的名称
            type: "primary", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "activate", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          },
          {
            label: "Inactivate ", //按钮显示的名称
            type: "primary", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "inactivate", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          }
        ];
      } else {
        this.generateOption.showToolbarButtonList = false;
        this.generateOption.showTableOperationButton = false;
      }

      if(this.isSuper){
        //如果是超级管理员，有所有的按钮
        this.generateOption.showToolbarButtonList = true;
        this.generateOption.showTableOperationButton = true;
        this.generateOption.tableOperationButtonList = [
          {
            label: "Modify", //按钮显示的名称
            type: "", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "modify", // 按钮点击时间触发的函数名称
            width: 100
          }
        ];
        this.generateOption.toolbarButtonList = [
          {
            label: "Create ", //按钮显示的名称
            type: "success", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "create", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          },
          {
            label: "Activate ", //按钮显示的名称
            type: "primary", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "activate", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          },
          {
            label: "Inactivate ", //按钮显示的名称
            type: "primary", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "inactivate", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          }
        ];
      }
    },
    handleTableValueClick(row, dbFieldName) {
      let routeData = '';
      if ("banner_id" === dbFieldName) {
        routeData = this.$router.resolve({
          path: "/banner-detail",
          query: {
            id: row.id,
            bannerId: row.banner_id,
            name: "Banner Master"
          }
        });
      } else if ("pi_status" === dbFieldName) {
        routeData = this.$router.resolve({
          path: "/banner-process-detail",
          query: {
            id: row.id,
            name: "Banner Master",
            title: row.pi_status,
            piId: row.pi_id
          }
        });
      }
      if ("approve_email" === dbFieldName) {
        try {
          let ids = JSON.parse(row.approve_file_id);
          ids && ids.forEach( id => {
            window.open(util.getFileSignature("", id))   // 下载文件
          });
        } catch (error) {
          console.log("转换id遇到错误", error);
        }
      } else {
        
      }
      window.open(routeData.href, '_blank')
    },
    handleTableDataFormatter(tableDataList) {
      try {
        for (let i = 0; i < tableDataList.length; i++) {
          let tableData = tableDataList[i];
          tableData.modify = {};
          tableData.inactivate = {};
          tableData.activate = {};
          if (
            tableData.pi_status === "已完成" ||
            tableData.pi_status === "已拒绝"
          ) {
            //无判断前
            // tableData.modify.disabled = false;

            if (this.role == "AE") {
              if (tableData.ae_editable == "true") {
                tableData.modify.disabled = false;
              } else {
                tableData.modify.disabled = true;
              }
            } else {
              tableData.modify.disabled = false;
            }

            if (tableData.active_status === "Active") {
              tableData.activate.disabled = true;
              tableData.inactivate.disabled = false;
            } else if (tableData.active_status === "Inactive") {
              tableData.activate.disabled = false;
              tableData.inactivate.disabled = true;
            } else {
              tableData.activate.disabled = true;
              tableData.inactivate.disabled = true;
            }
          } else {
            tableData.modify.disabled = true;
            tableData.activate.disabled = true;
            tableData.inactivate.disabled = true;
          }
        }
      } catch (e) {
        console.info(e);
      }

      this.$refs.basicComponent.setTableData(tableDataList);
    },
    handleTableButtonClick(row, name) {
      console.log(row,'nnnnnvvvv')
      // this.handleApprove([row.store_seq], name);
      this.selectStoreSeqList = [row.store_seq];
      this.operationResult = name;
      if (name === "modify") {
        this.editBannerBean.banner_name_cn = row.banner_name_cn;
        this.editBannerBean.banner_id = row.banner_id;
        this.editBannerBean.banner_name_en = row.banner_name_en;
        this.editBannerBean.banner_group_id = row.banner_group_id;
        this.editBannerBean.banner_group_name_cn = row.banner_group_name_cn;
        this.editBannerBean.banner_group_name_en = row.banner_group_name_en;
        this.editBannerBean.banner_channel = row.sub_channel;
        this.editBannerBean.channel_type_code = row.sub_channel;
        this.editBannerBean.banner_type_code = row.banner_type_code;
        this.editBannerBean.top_banner =
          row.is_top_banner === "Y" ? "true" : "false";
        this.changeBannerChannel(this.editBannerBean);
        this.editBannerBean.banner_type_id = row.banner_type_id;
        this.editBannerBean.id = row.id;
        this.editBannerBean.effective_from = row.effective_from

        this.editBannerDialogVisible = true;
        row.channel_type_code = row.sub_channel;
        this.selectRow = row;
      } else if (name === "activate") {
        this.confirmToActivateDialogVisible = true;
        this.bannerKeyIds = [];
        let bannerId = row.id;
        this.bannerKeyIds.push(bannerId);
      } else if (name === "inactivate") {
        this.confirmToInactivateDialogVisible = true;

        this.bannerKeyIds = [];
        let bannerId = row.id;
        this.bannerKeyIds.push(bannerId);
      } else {
        //nothing to do
      }
    },
    handleToolbarButtonClick(name) {
      if (name === "create") {
        this.addBannerDialogVisible = true;
        this.addBannerBean.banner_type_id = "";
          this.addBannerBean.banner_channel = "";
        if (this.role === "EM") {
          this.addBannerBean.banner_channel = "B2B";
        }
        this.addBannerBean.banner_name_cn = "";
        this.addBannerBean.banner_name_en = "";
        this.addBannerBean.banner_group_id = "";
        let now = new Date()
        let year = now.getFullYear()+''
        let month = now.getMonth()+1>10?now.getMonth()+1:'0'+(now.getMonth()+1)
        console.log(year,month)
        this.addBannerBean.effective_from = year +'-'+ month
      } else {
        let selection = this.$refs.basicComponent.getSelection();
        if (selection.length === 0) {
          this.$message.warning("Please choose at least one record");
          return;
        } else {
          this.bannerKeyIds = [];
          if (name === "activate") {
            this.confirmToActivateDialogVisible = true;
            for (let i in selection) {
              this.bannerKeyIds.push(selection[i].id);
            }
          }
          if (name === "inactivate") {
            this.confirmToInactivateDialogVisible = true;
            for (let i in selection) {
              this.bannerKeyIds.push(selection[i].id);
            }
          }
        }
      }
    },

    handleChange(itemValue) {},
    rolesValidationConfirmControl() {
      //AE    KAM       ChannelPm角色会弹窗提示
      let roles = JSON.parse(window.localStorage.getItem("roles"));
      let res;
      for (let i = 0; i < roles.length; i++) {
        if (roles[i] === "AE") {
          res = true;
        }
        if (roles[i] === "KAM") {
          res = true;
        }
        if (roles[i] === "Channel PM") {
          res = true;
        }
      }
      return res;
    },
    changeBannerChannel(bannerBean, flag) {
      bannerBean.banner_type_id = "";
      if (flag) {
        bannerBean.channel_type_code = bannerBean.banner_channel;
      }
    },

    saveBanner() {
      if (!this.validateBannerOperation(this.addBannerBean)) {
        return;
      }
      let url = this.baseStoreUrl + "/dms/banner/createBanner";
      let payload = {};
      payload.banner_name = this.addBannerBean.banner_name;
      payload.banner_type_id = this.addBannerBean.banner_type_id;
      payload.banner_name_cn = this.addBannerBean.banner_name_cn;
      payload.banner_name_en = this.addBannerBean.banner_name_en;
      payload.banner_group_id = this.addBannerBean.banner_group_id;
      payload.effective_from = this.addBannerBean.effective_from + '-01'
      this.dataLoading = true;
      this.submitSaveCreatLoading = true
      this.http
        .post(url, payload)
        .then(resp => {
          this.$message.success("Successful operation ");
          this.submitSaveCreatLoading = false;
          this.addBannerDialogVisible = false;
          this.dataLoading = false;
          this.$refs.basicComponent.runQuery();
        })
        .catch(error => {
          this.submitSaveCreatLoading = false;
          this.dataLoading = false;
          console.info(error);
          // this.$message.warning('Operation failure');
        });
    },
    handleActivate() {
      let url = this.baseStoreUrl + "/dms/banner/active";
      this.dataLoading = true;
      this.http
        .post(url, this.bannerKeyIds)
        .then(resp => {
          this.$message.success("Successful operation ");
          //请求activate的弹窗点击ok后，清空选项
          this.$refs.basicComponent.clearSelectionRowData();
          this.confirmToActivateDialogVisible = false;
          this.dataLoading = false;
          this.$refs.basicComponent.runQuery();
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
          // this.$message.warning('Operation failure');
        });
    },
    handleInactivate() {
      let url = this.baseStoreUrl + "/dms/banner/inactive";
      this.dataLoading = true;
      this.http
        .post(url, this.bannerKeyIds)
        .then(resp => {
          this.$message.success("Successful operation ");
          //请求Inactivate的弹窗,点击ok后，清空选项
          this.$refs.basicComponent.clearSelectionRowData();
          this.confirmToInactivateDialogVisible = false;
          this.dataLoading = false;
          this.$refs.basicComponent.runQuery();
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
          // this.$message.warning('Operation failure');
        });
    },
    funcJudgeBannerChange() {
      if (this.bannerTypeHasChanged) {
        if (this.thebannertypefirstpage !== this.thebannertypesecendpage) {
          return true;
        }
      }
      return false;
    },
    handleValidation() {
      this.submitEditLoading = true
      this.bannerTypeHasChanged = false;
      this.modifyBanner();
    },
    modifyBanner() {
      //console.log(this.thebannertypefirstpage==this.thebannertypesecendpage)
      if (this.bannerTypeHasChanged) {
        this.validationDialogVisible = true;
        this.validationDialogContent =
          "您所提交的信息变更申请，将触发对应Banner/门店的 data restatement,请确保跟进对应的restatement流程，变更的主数据也将在下个restate窗口生效。";
        return;
      }
      let url = this.baseStoreUrl + "/dms/banner/modifyBanner";
      let payload = {};
      payload.banner_name = this.editBannerBean.banner_name;
      payload.banner_type_id = this.editBannerBean.banner_type_id;
      payload.id = this.editBannerBean.id;
      payload.channel_type_code = this.editBannerBean.banner_channel;
      payload.banner_name_cn = this.editBannerBean.banner_name_cn;
      payload.banner_name_en = this.editBannerBean.banner_name_en;
      payload.banner_group_id = this.editBannerBean.banner_group_id;
      payload.is_top_banner = this.editBannerBean.top_banner;
      payload.effective_from = this.editBannerBean.effective_from+'-01'
      console.log(payload,'modifyBannerSubmit')
      //没有显示确认弹窗
      if(!this.validationDialogVisible){
        this.submitEditLoading = true
      }
      // this.dataLoading = true;
      let that = this;
      this.http
        .post(url, payload)
        .then(resp => {
          this.$message.success("Successful operation ");
          this.editBannerDialogVisible = false;
          this.validationDialogVisible = false;
          this.submitEditLoading = false;
          this.confirmToEditBannerDialogVisible = false;
          // this.dataLoading = false;
          this.$refs.basicComponent.runQuery();
        })
        .catch(error => {
          this.submitEditLoading = false;
          // this.dataLoading = false;
          console.info(error);
          // this.$message.warning('Operation failure');
        });
    },
    clearBannerKeys() {
      this.bannerKeyIds = [];
    },
    saveBannerGroup() {
      if (!this.bannerGroup.banner_group_name_cn) {
        this.$message.warning("Please input Banner Group CN");
        return;
      }
      if (!this.bannerGroup.banner_group_name_en) {
        this.$message.warning("Please input Banner Group EN");
        return;
      }
      let url = this.baseStoreUrl + "/dms/banner-group/add";
      if (this.bannerGroup.id !== undefined) {
        url = `${this.baseStoreUrl}/dms/banner-group/${this.bannerGroup.id}`;
      }
      this.dataLoading = true;
      this.CreateBannerGroupLoading = true
      this.http
        .post(url, this.bannerGroup)
        .then(resp => {
          this.addBannerGroupDialogVisible = false;
          // this.dataLoading = false;
          let data = resp.data;
          let bannerGroupId = data.banner_group_id;
          if (this.operationGroupType.create === this.openGroupType) {
            this.addBannerBean.banner_group_name_cn = data.banner_group_name_cn;
            this.addBannerBean.banner_group_name_en = data.banner_group_name_en;
            this.addBannerBean.banner_group_id = data.banner_group_id;
          }
          if (this.operationGroupType.modify === this.openGroupType) {
            this.editBannerBean.banner_group_name_cn = data.banner_group_name_cn;
            this.editBannerBean.banner_group_name_en = data.banner_group_name_en;
            this.editBannerBean.banner_group_id = data.banner_group_id;
          }

          this.getBannerGroup(true);
        })
        .catch(error => {
          this.dataLoading = false;
          this.CreateBannerGroupLoading = false
          console.info(error);
          // this.$message.warning('Operation failure');
        });
    },
    changeBannerType(bannerBean) {
      this.thebannertypesecendpage = bannerBean.banner_type_code;
      if (this.thebannertypefirstpageDataJudge) {
        this.thebannertypefirstpageDataJudge = false;
        this.thebannertypefirstpage = this.editBannerBean.banner_type_code;
      }
      let bannerTypeList = this.bannerChannelOptional[
        bannerBean.channel_type_code
      ];
      if (bannerTypeList) {
        bannerTypeList.forEach(bannerType => {
          if (bannerBean.banner_type_id === bannerType.id) {
            bannerBean.banner_type_code = bannerType.banner_type_code;
          }
        });
      }
    },
    changeBannerGroup(bannerBean) {
      this.bannerGroupOptional.forEach(bannerGroup => {
        if (bannerBean.banner_group_id === bannerGroup.banner_group_id) {
          bannerBean.banner_group_name_cn = bannerGroup.banner_group_name_cn;
          bannerBean.banner_group_name_en = bannerGroup.banner_group_name_en;
        }
      });
    },
    createBanner(type){
      this.bannerGroup = {
        banner_group_name_cn: "",
        banner_group_name_en: "",
      }
      this.bannerDiaTitle = "Create Banner Group";
      this.openGroupType = this.operationGroupType[type.toLowerCase()];
      this.addBannerGroupDialogVisible = true;
    },
    editBannerGroup(item, type) {
      this.bannerGroup = { ...item };
      this.openGroupType = this.operationGroupType[type.toLowerCase()];
      this.bannerDiaTitle = "Modify Banner Group";
      this.addBannerGroupDialogVisible = true;
    },
    confirmEditBanner() {
      if (!this.validateBannerOperation(this.editBannerBean)) {
        return;
      }
      this.editBannerBean["banner_name_cn_change"] = false;
      this.editBannerBean["banner_name_en_change"] = false;
      this.editBannerBean["channel_type_code_change"] = false;
      this.editBannerBean["banner_type_code_change"] = false;
      this.editBannerBean["banner_group_name_cn_change"] = false;
      this.editBannerBean["banner_group_name_en_change"] = false;
      this.editBannerBean["effective_from_change"] = false;
      //如果没有发生改变
      if (
        this.selectRow.banner_type_code == this.editBannerBean.banner_type_code
      ) {
        this.bannerTypeHasChanged = false;
      }

      this.confirmToEditBannerDialogVisible = true;
      //对比修改了的部分
      if (
        this.selectRow.banner_name_cn !== this.editBannerBean.banner_name_cn
      ) {
        this.editBannerBean["banner_name_cn_change"] = true;
      }
      if (
        this.selectRow.banner_name_en !== this.editBannerBean.banner_name_en
      ) {
        this.editBannerBean["banner_name_en_change"] = true;
      }
      if (
        this.selectRow.channel_type_code !==
        this.editBannerBean.channel_type_code
      ) {
        this.editBannerBean["channel_type_code_change"] = true;
      }
      if (
        this.selectRow.banner_type_code !== this.editBannerBean.banner_type_code
      ) {
        this.editBannerBean["banner_type_code_change"] = true;
        this.bannerTypeHasChanged = true;
      }
      if (
        this.selectRow.banner_group_name_cn !==
        this.editBannerBean.banner_group_name_cn
      ) {
        this.editBannerBean["banner_group_name_cn_change"] = true;
      }
      if (
        this.selectRow.banner_group_name_en !==
        this.editBannerBean.banner_group_name_en
      ) {
        this.editBannerBean["banner_group_name_en_change"] = true;
      }
      // 新增effective_from的change字段
      if (
        this.selectRow.effective_from !==
        this.editBannerBean.effective_from
      ) {
        this.editBannerBean["effective_from_change"] = true;
      }
    },
    validateBannerOperation(bannerBean) {
      if (!bannerBean.banner_name_cn) {
        this.$message.warning("Please input Banner CN");
        return false;
      }
      if (!bannerBean.banner_name_en) {
        this.$message.warning("Please input Banner EN");
        return false;
      }
      if (!bannerBean.banner_group_id) {
        this.$message.warning("Please Select Banner Group");
        return false;
      }
      if (!bannerBean.banner_channel) {
        this.$message.warning("Please Select Banner Channel");
        return false;
      }
      if (!bannerBean.banner_type_id) {
        this.$message.warning("Please Select Banner Type");
        return false;
      }
      if (!bannerBean.effective_from) {
        this.$message.warning("Please Select Effective Date");
        return false;
      }
      return true;
    },
    onInputLimit(value) {
      if (value.length > 64) {
        value = value.slice(0, 64);
        this.$message.warning("Max length: 64");
      }
    }
  }
};
</script>

<style>
.el-scrollbar__wrap {
  /* margin: 0 !important;
    overflow-x: hidden; */
}
</style>
<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.breadcrumb {
  background-color: transparent !important;
  margin-bottom: 0px;
}
.title {
  margin-left: 16px;
  font-size: 20px;
}
.el-form-item /deep/ .el-select {
  display: inline-block;
  width: 76%;
}
.banner-group-edit {
  float: right;
  font-size: 13px;
  margin-left: 15px;
}

.banner-group-edit:hover {
  text-decoration: underline;
  color: #409eff;

}
.add-banner-group /deep/ .el-form-item__label {
  width: 148px !important;
}
.add-banner-group /deep/ .el-form-item__content {
  margin-left: 148px !important;
}
.banner-group-select-group /deep/ .el-scrollbar__wrap {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 !important;
}
#banner-group-select-group /deep/ .el-scrollbar__bar.is-vertical {
  width: 0;
  top: 0;
}
// .el-loading-mask.is-fullscreen{
//   z-index: 3000 !important;
// }
.add-banner-group .el-form-item:nth-last-child(1) {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/store/banner_master/banner_master.vue